import { render, staticRenderFns } from "./RetailIndex.vue?vue&type=template&id=cf732692&scoped=true"
import script from "./RetailIndex.vue?vue&type=script&lang=js"
export * from "./RetailIndex.vue?vue&type=script&lang=js"
import style0 from "./RetailIndex.vue?vue&type=style&index=0&id=cf732692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf732692",
  null
  
)

export default component.exports